import { Injectable } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';
import { LoadType } from '@care-portals/api-interfaces';

import * as fromInvoice from './invoice.reducer';
import * as InvoiceActions from './invoice.actions';
import * as InvoiceSelectors from './invoice.selectors';

@Injectable()
export class InvoiceFacade {
  loading$ = this.store.pipe(select(InvoiceSelectors.getInvoiceLoading));
  allInvoice$ = this.store.pipe(select(InvoiceSelectors.getAllInvoice));
  selectedInvoice$ = this.store.pipe(select(InvoiceSelectors.getSelected));

  constructor(private store: Store<fromInvoice.InvoicePartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  // loadInvoice(loadType: LoadType, customerId: string, reset: boolean = false) {
  //   if (reset) {
  //     this.dispatch(InvoiceActions.resetInvoices());
  //   }

  //   this.dispatch(InvoiceActions.loadInvoice({ loadType, customerId }));
  // }

  loadInvoiceFromEmail(
    loadType: LoadType,
    email: string,
    reset: boolean = false
  ) {
    if (reset) {
      this.dispatch(InvoiceActions.resetInvoices());
    }

    this.dispatch(InvoiceActions.loadInvoiceFromEmail({ loadType, email }));
  }
}
